export default __webpack_public_path__ + "static/media/tune_up_arrow.ce774302.png";